<a href="https://www.bricomarche.pl/">
  <img alt="logo brico" class="header-image" src="assets/images/logo_brico.png">
</a>
<h1 class="headerLine"></h1>

<h2 class="header-info">Karta podarunkowa</h2>
<div *ngIf="!displayData" class="row main-row medium-size">
  <div [ngClass]="{'resize-col': !mediumScreen}" class="col-sm-6 data-div text-align-center">
    <div [ngClass]="{'display-none': !displayWarning}" class="col-sm-12 header-div">
      <span class="warning-info">{{warningMessage}}</span>
    </div>
    <div class="col-sm-12 header-div resize-medium-padding-top-40">
      <span>Sprawdź saldo i ważność Twojej karty podarunkowej</span>
    </div>
    <div class="col-sm-12">
      <input [(ngModel)]="cardNumber" [ngClass]="{'alone-input': !pinNeeded}" class="input-style"
             placeholder="Numer karty podarunkowej*">
      <input *ngIf="pinNeeded" [(ngModel)]="cardPin" class="input-style" placeholder="Numer PIN karty podarunkowej*">
    </div>

    <div class="col-sm-12 ">
      <button (click)="checkCard()" [disabled]="checkPinValidation()" class="button">
        <span *ngIf="loading" aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
        Sprawdź kartę
      </button>
    </div>
  </div>
  <div class="col-sm-6 photo-div">
    <img *ngIf="!mediumScreen" alt="card image" class="card-image" src="assets/images/karta_pokazowa.png">
    <img *ngIf="mediumScreen" alt="card image" class="img-fluid" src="assets/images/karta_pokazowa.png">
  </div>
</div>
<app-info-display
  (hideDataEmitter)="hideData($event)"
  *ngIf="displayData"
  [internetPaymentsActive]="pinNeeded"
  [cardBalanceBody]="cardBalanceBody"
  [cardHistoryBody]="cardHistoryBody">
</app-info-display>

